module.exports = __webpack_public_path__ + "static/media/close.ebf338e3.png";